import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-paper px-5 py-8 sm:py-16" data-id="element-82" data-mp="1hbgu4bwv3v38">
      <div className="mx-auto max-w-2xl" data-id="element-83" data-mp="1cfjfca18ywsk">
        <h2 className="text-center font-serif-display text-2xl font-bold text-ink sm:text-4xl" data-id="element-84" data-mp="1ccnd49id9lyb">
          Domande frequenti
        </h2>

        <div className="mt-6 divide-y divide-cobalt/20 border-y border-cobalt/20 sm:mt-8" data-id="element-85" data-mp="252vz6cg0wqi6">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.question} data-id="element-86" data-mp="1v5hicbq6tzpc" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex min-h-[48px] w-full items-center justify-between gap-4 py-4 text-left" data-id="element-87" data-mp="1v4g6w659fb73">
                  <span className="text-sm font-semibold text-ink sm:text-base" data-id="element-88" data-mp="1korvps1joems">{faq.question}</span>
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-cobalt/15 text-cobalt-deep" data-id="element-89" data-mp="1plry9sz6qz95">
                    {isOpen ? <MinusIcon className="h-4 w-4" aria-hidden="true" data-id="element-90" data-mp="1fodmi6o7iyn6" /> : <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-91" data-mp="11xiip8skf7qg" />}
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-92" data-mp="16oqrc2m2mp2k">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-93" data-mp="s045di1xuz2d">
                      <p className="pb-4 text-sm leading-relaxed text-ink/70" data-id="element-94" data-mp="n1sxhcv7eyms">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}